<template>
  <div
    aria-busy="true"
    data-testid="ctSearchContainerSkeleton"
  >
    <div class="flex flex-col gap-6 mt-4 mb-2 lg:flex-row lg:justify-between lg:mb-12">
      <SkeletonLoader
        v-if="showBreadcrumbs"
        height="26px"
        width="800px"
        item-classes="max-w-full"
        class="order-last px-4 lg:order-first lg:px-0"
        data-testid="ctBreadcrumbsSkeleton"
      />
      <SkeletonLoader
        v-if="showSearchResultCount"
        height="24px"
        width="320px"
        item-classes="max-w-full mx-auto lg:mx-0"
        class="px-4 lg:px-0"
        data-testid="ctSearchResultCountSkeleton"
      />
      <div class="flex items-center justify-end px-4 lg:px-0 lg:ml-auto">
        <SkeletonLoader
          height="40px"
          class="w-1/2 pr-2.5 lg:hidden"
          data-testid="ctFilterButtonSkeleton"
        />
        <div class="flex items-center w-1/2 lg:w-auto">
          <SkeletonLoader
            height="20px"
            width="58px"
            class="hidden lg:block"
          />
          <SkeletonLoader
            height="38px"
            class="pl-2.5 w-full lg:w-[191px]"
          />
        </div>
      </div>
    </div>

    <div class="flex gap-2 items-start">
      <CtSearchFiltersSkeleton
        class="hidden lg:block w-80 flex-shrink-0"
        :show-search-box="showSearchBox"
      />

      <SkeletonLoader
        :number-of-items="PRODUCT_CARD_COUNT"
        height="751px"
        width="var(--product-card-width)"
        class="flex-grow min-w-0 grid grid-cols-[repeat(auto-fill,var(--product-card-width))] gap-10
          justify-center px-5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
// Shaped like CtSearchContainer, so the footer doesn't jump up and back while the first results load.
defineOptions({ name: 'CtSearchContainerSkeleton' });

withDefaults(defineProps<{
  showSearchBox?: boolean;
  showBreadcrumbs?: boolean;
  showSearchResultCount?: boolean;
}>(), {
  showSearchBox: false,
  showBreadcrumbs: false,
  showSearchResultCount: false,
});

// Two rows of the widest grid (4 columns at max-w-screen-4xl), so the footer stays below the fold.
const PRODUCT_CARD_COUNT = 8;
</script>
